module.exports = __webpack_public_path__ + "img/75.status_garbage_can.c363b595.svg";